import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [가상화 로그 > 정책 목록] 가상화 로그 정책 목록 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getVirtualLogRuleList(params) {
    return axios.post(`${baseUrl}/settings/virtuallog/get-virtual-log-rule-list.do`, params);
  },
  /**
   * [가상화 로그 > 정책 목록] 가상화 로그 구분 목록 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getVmsLogPolicyTypeList() {
    return axios.get(`${baseUrl}/settings/virtuallog/get-vms-log-policy-type-list.do`);
  },
  /**
   * [가상화 로그 > 정책 목록] 가상화 로그 정책 추가
   * @author jeee12
   * @return {[type]} [description]
   */
  addVmsLogPolicy(params) {
    return axios.post(`${baseUrl}/settings/virtuallog/add-vms-log-policy.do`, params);
  },
  /**
   * [가상화 로그 > 정책 목록] 가상화 로그 정책 수정
   * @author jeee12
   * @return {[type]} [description]
   */
  updateVmsLogPolicy(params) {
    return axios.post(`${baseUrl}/settings/virtuallog/update-vms-log-policy.do`, params);
  },
  /**
   * [가상화 로그 > 정책 목록] 가상화 로그 정책 삭제
   * @author jeee12
   * @return {[type]} [description]
   */
  deleteVmsLogPolicy(params) {
    return axios.post(`${baseUrl}/settings/virtuallog/delete-vms-log-policy.do`, params);
  },
  /**
   * [수집 설정 > 가상화 로그 설정] 가상화 로그 정책의 대상목록을 조회
   * @author najongdang
   * @return {[type]} [description]
   */
  getVmsLogPolicyTargetList(params) {
    return axios.post(`${baseUrl}/settings/virtuallog/get-vms-log-policy-target-list.do`, params);
  },
  /**
   * [수집 설정 > 가상화 로그 설정] 선택된 가상화 로그 정책의 적용대상을 수정.
   * @author najongdang
   * @return {[type]} [description]
   */
  updateVmsLogPolicyTargetList(params) {
    return axios.post(`${baseUrl}/settings/virtuallog/update-vms-log-policy-target-list.do`, params);
  },
  /**
   * [수집 설정 > 가상화 로그 설정] 가상화대상을 제외한 장비의 obj_define_id 목록을 조회
   * @author najongdang
   * @return {[type]} [description]
   */
  getObjDefineIdList(params) {
    return axios.get(`${baseUrl}/settings/virtuallog/get-obj-define-id-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/virtuallog-settings.js